export default __webpack_public_path__ + "static/media/Subodh_Singh_Resume.5a804547.pdf";